import { NgModule } from '@angular/core';

import { AdminRootPageModule } from 'pages/admin-root/admin-root.module';
import { AdminConfigPageModule } from 'pages/admin-config/admin-config.module';
import { AdminKeygenPageModule } from 'pages/admin-keygen/admin-keygen.module';
import { AdminTextListPageModule } from 'pages/admin-text-list/admin-text-list.module';
import { AdminEditTextPageModule } from 'pages/admin-edit-text/admin-edit-text.module';
import { AdminExerciseListPageModule } from 'pages/admin-exercise-list/admin-exercise-list.module';
import { AdminExerciseSlotListPageModule } from 'pages/admin-exercise-slot-list/admin-exercise-slot-list.module';
import { AdminEditExerciseSlotPageModule } from 'pages/admin-edit-exercise-slot/admin-edit-exercise-slot.module';
import { AdminUserSearchPageModule } from 'pages/admin-user-search/admin-user-search.module';
import { AdminUserPermissionsPageModule } from 'pages/admin-user-permissions/admin-user-permissions.module';
import { AdminUserSubscriptionPageModule } from 'pages/admin-user-subscription/admin-user-subscription.module';
import { AdminImpersonatedUserPageModule } from 'pages/admin-impersonated-user/admin-impersonated-user.module';

const ADMIN_PAGE_MODULES = [
  AdminRootPageModule,
  AdminConfigPageModule,
  AdminKeygenPageModule,
  AdminTextListPageModule,
  AdminEditTextPageModule,
  AdminExerciseListPageModule,
  AdminExerciseSlotListPageModule,
  AdminEditExerciseSlotPageModule,
  AdminUserSearchPageModule,
  AdminUserPermissionsPageModule,
  AdminUserSubscriptionPageModule,
  AdminImpersonatedUserPageModule,
];

/**
 * The admin-only screens, reached from the Admin menu.
 *
 * One of the app's per-area page groups: it only groups page modules together,
 * declaring nothing of its own and adding no providers. Why these files exist and
 * what keeps them honest: `design-docs/angular-components.md`, "Creating New
 * Components", step 4.
 */
@NgModule({
  imports: ADMIN_PAGE_MODULES,
  exports: ADMIN_PAGE_MODULES,
})
export class AdminPagesModule { }
